export const ROUTE = {
  ADMIN: {
    PATIENTS: "/admin/patients",
    PATIENTS_EDIT: "/admin/patient/:id/edit",
    CLINIC: "/admin/clinics",
    CLINIC_EDIT: "/admin/clinics/:id/edit",
    POST: "/admin/posts",
    HELP: "/admin/help-faqs",
    HELP_CREATE: "/admin/help-faqs/create",
    HELP_EDIT: "/admin/help-faqs/:id/edit",
    SETTING: "/admin/setting",
    SETTING_THRESHOLD: "/admin/setting-threshold",
    SETTING_PASSWORD: "/admin/setting-password",
    SETTING_DEVICE: "/admin/setting-device",
    SETTING_CERTIFICATE: "/admin/setting-certificate",
    ARTICLES: "/admin/articles",
    ARTICLES_CREATE: "/admin/articles/create",
    ARTICLES_EDIT: "/admin/articles/:id/edit",
    NOTICES: "/admin/notices",
    NOTICES_CREATE: "/admin/notices/create",
    NOTICES_EDIT: "/admin/notices/:id/edit",
    GRAPH: "/admin/:id/graph",
  },
  CLINIC: {
    CODE: "/clinic/code",
    SETTING: "/clinic/setting",
    PATIENT: "/clinic/patient",
    PATIENT_EDIT: "/clinic/patient/:id/edit",
    GRAPH: "/clinic/:id/graph",
    HELP_PAGE: "/clinic/help",
    NOTIFICATION: "/clinic/notification",
    FIRST_PAGE: "/clinic/first",
  },
  PUBLIC: {
    LOGIN: "/login",
    HOME: "/home",
    SIGN_UP: "/sign-up",
    RESET_PASSWORD: "/reset-password",
    LOGOUT: "/logout",
    TERMS_POLICY: "/terms-policy/:id",
    DELETE_ACCOUNT: "/delete-account",
    GRAPH: "/patient/:id/graph",
  },
};
